import { API_BASE } from '../config';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserSurveyPageLeft from './UserSurveyPage_left';
import UserSurveyPageRight from './UserSurveyPage_right';
import './pages.css';
import './UserSurveyPage.mobile.css';

const UserSurveyPage = () => {
    const [sites, setSites] = useState([]);
    const [selectedSite, setSelectedSite] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(() => window.matchMedia?.('(max-width: 800px)').matches ?? false);
    const [surveyOpen, setSurveyOpen] = useState(false);
    const [loadError, setLoadError] = useState('');

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };

    const fetchSites = useCallback(async () => {
        setIsLoading(true);
        try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/api/users/sites`, {
            headers: {
            Authorization: `Bearer ${token}`
            }
        });
        const data = await response.json();
        if (!response.ok || !Array.isArray(data)) throw new Error('sites_load_failed');
        setSites(data);
        setLoadError('');
        } catch (error) {
        console.error('사이트 목록을 가져오는 데 실패했습니다:', error);
        setLoadError('사이트 목록을 불러오지 못했습니다. 다시 시도해주세요.');
        } finally {
        setIsLoading(false);
        }
    }, []);
    
    

    useEffect(() => {
        fetchSites();
        document.body.classList.add('user-survey-bg');
        return () => {
        document.body.classList.remove('user-survey-bg');
    };
    }, [fetchSites]);

    useEffect(() => {
        const media = window.matchMedia?.('(max-width: 800px)');
        const update = () => setIsMobile(media.matches);
        media?.addEventListener('change', update);
        return () => media?.removeEventListener('change', update);
    }, []);

    const selectSite = (site) => {
        setSelectedSite(previous => previous?.survey_id === site.survey_id ? previous : site);
        setSurveyOpen(true);
        if (isMobile) window.scrollTo({ top: 0 });
    };


return (
    <div className={`user-survey-page${isMobile ? ' is-mobile' : ''}`}>
        <div className="top-right-button-group" hidden={isMobile && surveyOpen}>
        {isMobile && <span className="mobile-brand">국민평가</span>}
        <button onClick={handleLogout} className="navigate-button logout-button">
        로그아웃
        </button>
        </div>
        <div className="user-container">

        <UserSurveyPageLeft
            sites={sites}
            isLoading={isLoading}
            onSelectSite={selectSite}
            selectedSite={selectedSite}
            isMobile={isMobile}
            hidden={isMobile && surveyOpen}
            loadError={loadError}
            onRetry={fetchSites}
        />
        <UserSurveyPageRight 
            selectedSite={selectedSite} 
            onSurveySubmitted={fetchSites} 
            isMobile={isMobile}
            hidden={isMobile && !surveyOpen}
            onBackToList={() => { setSurveyOpen(false); window.scrollTo({ top: 0 }); }}
        />

        
        <footer className="footer" hidden={isMobile && surveyOpen}>
            <p className="version">Copyright 2025. Headers all rights reserved.
            v3.0.1</p>
        </footer>

        </div>
    </div>
        );
}


/*별 사용하는 경우
import StarRating from './StarRating';
<StarRating /> */

export default UserSurveyPage;
